import { render, staticRenderFns } from "./DettaglioIntervento.vue?vue&type=template&id=6b6d8b02&"
import script from "./DettaglioIntervento.vue?vue&type=script&lang=js&"
export * from "./DettaglioIntervento.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioIntervento.vue?vue&type=style&index=0&id=6b6d8b02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports